// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__B1qCr","info":"PatientInfo_info__fYbPJ"};